<template>
  <div class="decoration-config-collapse">
    <el-collapse
      v-model="currentActive"
      accordion
      @change="handleOnActiveClick"
    >
      <el-collapse-item
        v-for="(item, index) in componentsMap"
        ref="collapseItem"
        :key="index"
        :name="item.name"
      >
        <template slot="title">
          <div
            class="decoration-config__collapse__title"
          >
            <!-- <span class="collapse-biz__title">
              {{ item.title }}
            </span> -->
            <decoration-config-collapse-title
              :item="item"
              :data="data"
              :active="currentActive"
              @on-save-title-click="hanldeOnSaveTitleClick"
            >
            </decoration-config-collapse-title>
            <mk-button
              v-if="item.showButton && item.name === currentActive"
              class="collapse-biz__new"
              type="text"
              :disabled="!disabledNewAdd"
              @click.stop="handleOnNewClick(item)"
            >
              <i class="el-icon-plus"></i>{{ '新增' + item.defaultTitle }}
            </mk-button>
          </div>
        </template>
        <component
          :is="item.component"
          :data="data[item.name]"
          @on-delete-click="handleOnDeleteClick"
          @on-radio-change="handleOnRadioChange"
          @disabled-add="disabledBtn = true"
        >
        </component>
      </el-collapse-item>
    </el-collapse>
  </div>
</template>

<script>
export default {
  name: 'DecorationConfigCollapse',
  props: {
    // 组件列表映射
    componentsMap: {
      type: Object,
      default () {
        return {}
      }
    },
    // 数据
    data: {
      type: Object,
      default () {
        return {
          disabledBtn: false
        }
      }
    },
    // 当前激活的折叠面板的数据
    active: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      currentActive: this.active
    }
  },
  computed: {
    disabledNewAdd () {
      if (this.currentActive === 'documents' && this.disabledBtn) {
        return !this.disabledBtn
      } else {
        return this.data[this.currentActive].length < this.componentsMap[this.currentActive].limit
      }
    }
  },
  watch: {
    active () {
      this.currentActive = this.active
    }
  },
  mounted () {
    this.removeEnterClick()
  },
  methods: {
    // 这里需要触发外部组件事件
    handleOnDeleteClick (data) {
      this.$emit('on-delete-click', data)
    },
    handleOnRadioChange (value) {
      this.$emit('on-radio-change', value)
    },
    handleOnNewClick (item) {
      this.$emit('on-new-click', item)
    },
    handleOnActiveClick () {
      this.$emit('on-active-click', this.currentActive)
    },
    hanldeOnSaveTitleClick (item) {
      this.$emit('on-save-title-click', item)
    },
    getCurrentSelectedNumber (active) {
      const currentList = this.data[active] ? this.data[active] : []
      return currentList.length
    },
    removeEnterClick () {
      this.$refs.collapseItem.forEach(item => {
        item.handleEnterClick = null
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.decoration-config-collapse {
  .collapse-biz__new {
    float: right;
  }

  .decoration-config__collapse__title {
    display: flex;
    width: 100%;
    height: 44px;
    line-height: 44px;
    padding: 0 14px 0 12px;

    .el-icon-plus {
      margin-right: 4px;
    }
  }

  .decoration-config__collapse__title:hover {
    background-color: #f7f7f7;
  }

  .el-collapse {
    /deep/.el-icon-arrow-right {
      display: none;
    }

    /deep/.el-collapse-item__header {
      height: 44px;
    }

    /deep/.el-collapse-item__content {
      padding-bottom: 30px;
    }
  }
}
</style>
